module.exports = __webpack_public_path__ + "img/agma2001-D04_fig12-3.2f4ea53a.png";